/**
 * Time Thresholds for Age Calculations
 * Values in seconds - used for calculating issue age in Sentry dashboard
 */

export const TIME_THRESHOLDS = {
  /** 1 year in seconds (365 days) */
  YEAR: 31536000,

  /** 1 month in seconds (30 days) */
  MONTH: 2592000,

  /** 1 week in seconds (7 days) */
  WEEK: 604800,

  /** 1 day in seconds (24 hours) */
  DAY: 86400,

  /** 1 hour in seconds */
  HOUR: 3600,

  /** 1 minute in seconds */
  MINUTE: 60,
} as const

/**
 * Age Calculation Constants
 */
export const AGE_CALCULATION = {
  /** Threshold for switching from rounding to truncating months (6 months) */
  MONTH_ROUNDING_THRESHOLD: 6,
} as const
